import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from './reactSelect/select.component';
import { connectionsByTypeOptionsSelector, connectionByTypeSelector, periodOrCurrentSelector } from './store/selectors';
import { fetchConnectionsByType, selectConnectionByType } from './store/actions';
import { ConnectionPropTypes, ConnectionsPropTypes } from './propTypes/connection';
import { PeriodPropTypes } from './propTypes/period';
import { filterSelectFactory } from '../utils/dropdownsHelpers';
import { byField } from '../utils/sorting';

const filterSelectDefault = filterSelectFactory();

class ConnectionByTypeDropdown extends PureComponent {
  static propTypes = {
    connections: PropTypes.arrayOf(ConnectionsPropTypes).isRequired,
    connection: ConnectionPropTypes,
    selectConnectionByType: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    period: PeriodPropTypes,
    fetchConnectionsByType: PropTypes.func,
    connType: PropTypes.string,
  };

  static defaultProps = {
    disabled: false,
  };

  componentDidMount() {
    const { period, connType } = this.props;
    if (!!period || !!connType) {
      fetchConnectionsByType(period, connType);
    }
  }

  componentDidUpdate(prevProps) {
    const { period, connType } = this.props;
    if (!!period && (prevProps.period?.name !== period?.name)) {
      fetchConnectionsByType(period, connType);
    }
  }

  onConnectionChange = selectedConnection => {
    const { connections, selectConnectionByType, onChange } = this.props;
    const value = selectedConnection ? selectedConnection.value : null;
    const connectionToSelect = connections.find(connection => connection.value === value);

    if (connectionToSelect) {
      selectConnectionByType(connectionToSelect.value);
      if (onChange) {
        onChange(connectionToSelect);
      }
    }
  };

  render() {
    const { connection, connections, disabled } = this.props;

    const selectedConnection = connection ? connection.connName : '';
    const sortedConnections = connections.sort(byField('label'));

    return (
      <Select
        className="select-connection"
        clearable={false}
        filterOptions={filterSelectDefault}
        name="connection"
        options={sortedConnections}
        labelKey="label"
        onChange={this.onConnectionChange}
        disabled={disabled}
        scrollMenuIntoView={false}
        value={selectedConnection}
        virtualized
      />
    );
  }
}

export default connect(
  function mapStateToProps(state) {
    return {
      connection: connectionByTypeSelector(state),
      connections: connectionsByTypeOptionsSelector(state),
      period: periodOrCurrentSelector(state),
    };
  },
  {
    selectConnectionByType,
  }
)(ConnectionByTypeDropdown);
